// App.jsx (remove react-scroll entirely)
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { TranslationProvider } from "./i18n";
import OneDayPage from "./components/OneDayPage";
import TwoDayPage from "./components/TwoDayPage";
import Gallery from "./components/Gallery";
import GalleryModeration from "./components/GalleryModeration";

function App() {
  return (
    <TranslationProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/1day" replace />} />
          <Route
            path="/1day"
            element={
              <>
                <OneDayPage />
                <Toaster />
              </>
            }
          />
          <Route
            path="/2day"
            element={
              <>
                <TwoDayPage />
                <Toaster />
              </>
            }
          />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/gallery-admin" element={<GalleryModeration />} />
          {/* <Route path="/impressum" element={<Impressum />} /> */}
        </Routes>
      </Router>
    </TranslationProvider>
  );
}

export default App;
